import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import { BoxPermissionsApi } from 'src/lib/api/item-store/permissions/boxPermissions';
import { permissionsQueryKeys } from 'src/lib/query-keys/permissions';

export const boxesUserPermissionsInfiniteQueryOptions = ({ limit }: { limit?: number } = {}) =>
  infiniteQueryOptions({
    queryKey: permissionsQueryKeys.boxes.allUsersPermissions,
    queryFn: ({ pageParam }) =>
      BoxPermissionsApi.getAllBoxesUserPermissions({ cursor: pageParam, limit }),
    initialPageParam: '',
    getNextPageParam: (lastPage) => lastPage.cursor,
    select: (paginatedData) => paginatedData.pages.flatMap((page) => page.data),
  });

export const useBoxesUserPermissionsInfiniteQuery = ({ limit }: { limit?: number } = {}) =>
  useInfiniteQuery(boxesUserPermissionsInfiniteQueryOptions({ limit }));
